// extracted by mini-css-extract-plugin
module.exports = {"paginated-buttons":"styles-module__paginated-buttons___IKhDV"};